module.exports = {"name":"thunderjs","version":"1.0.0","private":true,"description":"打包移动端页面","m":"1.5.0m","main":"index.js","scripts":{"m":"node webpack.config.js"},"licence":"ISC","devDependencies":{"babel-core":"^6.26.0","babel-loader":"^7.1.2","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","compressed-string-loader":"^0.0.1","scp2":"git+https://github.com/jqroom/node-scp2.git","webpack":"^3.5.5"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 84
// module chunks = 2